import VMenu from './VMenu.js'

export default {
  VMenu
}



// WEBPACK FOOTER //
// ./src/components/menus/index.js